import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Section } from '@atlaskit/menu';
import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { useTeamBiDirectionalExp } from '../hooks/use-team-connection-exp';

import { ItemSkeleton } from './item-skeleton';

const loadingContainerStylesOld = xcss({
	backgroundColor: 'elevation.surface.overlay',
	borderRadius: 'radius.small',
	boxShadow: 'elevation.shadow.overlay',
	width: '320px',
	display: 'block',
	alignItems: 'center',
	justifyContent: 'center',
});

const styles = cssMap({
	headerSkeleton: {
		paddingTop: token('space.250'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.200'),
		paddingRight: token('space.200'),
	},
	badgeSkeleton: {
		borderRadius: token('radius.small'),
		height: '16px',
		width: '24px',
	},
	titleSkeleton: {
		borderRadius: token('radius.full'),
		height: '16px',
		width: '160px',
	},
	loadingContainerStyles: {
		backgroundColor: token('elevation.surface.overlay'),
		borderRadius: token('radius.large'),
		boxShadow: token('elevation.shadow.overlay'),
		width: '320px',
		display: 'block',
		alignItems: 'center',
		justifyContent: 'center',
	}
});

const TeamSelectorSkeleton = (): React.JSX.Element => {
	const { isTeamBiDirectionalEnabled } = useTeamBiDirectionalExp();
	return (
		<Box
			testId="testId-team-selector-skeleton"
			xcss={fg('yurree_jjj_3_ads_fixes') ? styles.loadingContainerStyles : loadingContainerStylesOld}
		>
			<Inline xcss={styles.headerSkeleton} spread="space-between" alignBlock="center">
				<Box xcss={styles.titleSkeleton} backgroundColor="color.background.neutral" />
				<Box xcss={styles.badgeSkeleton} backgroundColor="color.background.neutral" />
			</Inline>
			<Section isList>
				{[...Array(3)].map((_, index) => (
					<ItemSkeleton key={index} />
				))}
			</Section>
			{isTeamBiDirectionalEnabled && (
				<Section hasSeparator>
					<ItemSkeleton showControl={false} />
				</Section>
			)}
		</Box>
	);
};

export default TeamSelectorSkeleton;
